/**
 * @generated SignedSource<<cf870b812fa842f13a24c4391af7f57b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraCheckboxesField_Platform$data = {
  readonly fieldConfig: {
    readonly isEditable: boolean | null;
    readonly isRequired: boolean | null;
  } | null;
  readonly fieldOptions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly value: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly name: string;
  readonly selectedOptions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly value: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "JiraCheckboxesField_Platform";
};
export type JiraCheckboxesField_Platform$key = {
  readonly " $data"?: JiraCheckboxesField_Platform$data;
  readonly " $fragmentSpreads": FragmentRefs<"JiraCheckboxesField_Platform">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "concreteType": "JiraOptionEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "value"
          }
        ]
      }
    ]
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "JiraCheckboxesField_Platform",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isRequired"
        },
        {
          "kind": "ScalarField",
          "name": "isEditable"
        }
      ]
    },
    {
      "concreteType": "JiraOptionConnection",
      "kind": "LinkedField",
      "name": "selectedOptions",
      "plural": false,
      "selections": (v0/*: any*/)
    },
    {
      "concreteType": "JiraOptionConnection",
      "kind": "LinkedField",
      "name": "fieldOptions",
      "plural": false,
      "selections": (v0/*: any*/)
    }
  ],
  "type": "JiraCheckboxesField"
};
})();

(node as any).hash = "3e45bfdb7cc15e25fa0063d380b856d9";

export default node;
